import { render, staticRenderFns } from "./SimpleStatCard.vue?vue&type=template&id=2aefa12d&scoped=true&lang=pug&"
import script from "./SimpleStatCard.vue?vue&type=script&lang=js&"
export * from "./SimpleStatCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleStatCard.vue?vue&type=style&index=0&id=2aefa12d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aefa12d",
  null
  
)

export default component.exports